import { defineComponent as _defineComponent } from 'vue'

import { onMounted } from 'vue';
import axios from 'axios';

export default /*#__PURE__*/_defineComponent({
  __name: 'OauthCallback',
  setup(__props) {

const appCode = process.env.VUE_APP_OAUTH_APPCODE;
const getAccessToken = async (code) => {
  try {
    const response = await axios.get(`/ngiam-rst/oauth2/token?appcode=${appCode}&secret=${process.env.VUE_APP_OAUTH_SECRET}&code=${code}`);
    const accessToken = response.data.accessToken;
    localStorage.setItem('accessToken', accessToken);
    return accessToken;
  } catch (error) {
    console.error('Error fetching token:', error);
  }
}

const getUserInfo = async (code) => {
  try {
    const accessToken = await getAccessToken(code);
    const response = await axios.get(`/ngiam-rst/oauth2/userinfo?appcode=${appCode}&secret=${process.env.VUE_APP_OAUTH_SECRET}&token=${accessToken}`);
    localStorage.setItem('accountName', response.data.accountName);
    window.location.href = `${process.env.VUE_APP_SSO_CALLBACK_URL}`;
  } catch (error) {
    console.error('Error fetching user info:', error);
  }
}

onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  if (code) {
    getUserInfo(code);
  }
});

return (_ctx: any,_cache: any) => {
  return " Authorizing... "
}
}

})